
import { useEffect, useRef } from "react";
import backgroundMusic from "../assets/audio/background.mp3";

const BackgroundMusic = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio(backgroundMusic);
    audio.loop = true;
    audio.volume = 0.25;
    audioRef.current = audio;

    const isEnabled = () => localStorage.getItem("backgroundMusic") !== "off";

    const startMusic = () => {
      if (isEnabled()) {
        audio.play().catch(() => {});
      }
      window.removeEventListener("click", startMusic);
      window.removeEventListener("touchstart", startMusic);
    };

    const toggleMusic = () => {
      if (!audioRef.current) return;

      if (isEnabled()) {
        localStorage.setItem("backgroundMusic", "off");
        audioRef.current.pause();
      } else {
        localStorage.setItem("backgroundMusic", "on");
        audioRef.current.play().catch(() => {});
      }

      window.dispatchEvent(new Event("backgroundMusicChanged"));
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        audio.pause();
      } else if (isEnabled()) {
        audio.play().catch(() => {});
      }
    };

    window.addEventListener("click", startMusic);
    window.addEventListener("touchstart", startMusic);
    window.addEventListener("toggleBackgroundMusic", toggleMusic);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      audio.pause();
      window.removeEventListener("click", startMusic);
      window.removeEventListener("touchstart", startMusic);
      window.removeEventListener("toggleBackgroundMusic", toggleMusic);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null;
};

export default BackgroundMusic;
